// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.06.2017 14:23:49
import { ScheduleDatePeriod_abstract } from './../../abstract/SagaBase/Defines/ScheduleDatePeriod_abstract';
export class ScheduleDatePeriod extends ScheduleDatePeriod_abstract {}
